module.exports = __webpack_public_path__ + "img/store_web.07dc3d90.svg";